export default __webpack_public_path__ + "static/media/logoProvisoria-icone.ab48ed39.png";